// Wave UX-2.1 Item 1 (2026-05-23) — 외부 바이어 웹 언어 전환 4지 dropdown.
// 헤더 우측 (로그아웃 옆) 권장 placement.

import React from 'react';
import { useT, useLocale } from './I18nProvider';

function LanguageSwitcher() {
  var t = useT();
  var loc = useLocale();
  return (
    <select
      aria-label={t('commonLanguage')}
      value={loc.locale}
      onChange={function(e){ loc.setLocale(e.target.value); }}
      style={{
        height: 34, padding: '0 10px',
        border: '1.5px solid #e2e8f0', borderRadius: 8,
        background: 'white', fontSize: 13, fontWeight: 600,
        color: '#475569', cursor: 'pointer',
        fontFamily: "'Pretendard',sans-serif",
      }}>
      <option value="ko">{t('langKo')}</option>
      <option value="en">{t('langEn')}</option>
      <option value="ar">{t('langAr')}</option>
      <option value="ru">{t('langRu')}</option>
    </select>
  );
}

export default LanguageSwitcher;
